import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import "./App.css";

import ServicesPage from "./pages/Services.js";
import HomePage from "./pages/Home.js";
import AboutPage from "./pages/About.js";
import BookingPage from "./pages/Booking.js";
import GalleryPage from "./pages/Gallery.js";
import ContactPage from "./pages/Contact.js";
import AdminPage from "./pages/Admin.js";

import KuNyeBlog from "./pages/blog/KuNye.js";
import NineBreathingExerciseBlog from "./pages/blog/NineBreathingExercise.js";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CareerPage from "./pages/Career.js";
import JobApplication from "./pages/JobApplication.js";

function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/booking" element={<BookingPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/career" element={<CareerPage />}></Route>
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/job_application" element={<JobApplication />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/kuNye" element={<KuNyeBlog />} />
          <Route
            path="/nineBreathingExercise"
            element={<NineBreathingExerciseBlog />}
          />
          {/* Add more routes here as needed */}
        </Routes>
      </Router>
    </>
  );
}

export default App;
